<template>
  <div id="app" data-server-rendered="true">
       <div class="work-in-process">
         <p>Сайт на реконструкції</p>
       </div>
    <!-- <Header/>
    <router-view/>
    <Footer/>
    <Plashka/> -->
  </div>
</template>
<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Plashka from "@/components/Plashka";

export default {
  components: {
    Header,
    Footer,
    Plashka
  },
  methods: {
    setLocale() {
      this.$i18n.locale = this.$route.params.lang;
    }
  },
  created() {
    this.setLocale();
  },
  updated() {
    this.setLocale();
  }
};
</script>
<style lang="scss">
// Helper global styles
@import "~@/assets/scss/global/_reset";
@import "~@/assets/scss/global/_grid";
@import "~@/assets/scss/global/_fonts";
@import "~@/assets/scss/global/_mixins";
@import "~@/assets/scss/global/_default";

.work-in-process {
  position: fixed;
  width: 100%;
  height: 100%;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 15px;

  p {
    font-size: 64px;
    color: black;
    text-align: center;

    @media screen and (max-width: 1240px) {
      font-size: 52px;
    }
    @media screen and (max-width: 1024px) {
      font-size: 36px;
    }

  }
}
</style>
